import { ReactNode, useEffect, useCallback, useState, FC, MouseEvent } from 'react';
import ReactDOM from 'react-dom';
import FragmentsModalContent from '../../modules/fragments/components/RulesModal/ModalContent';
import MetroModalContent from '../../modules/metro/components/RulesModal/ModalContent';

export interface IModalProps {
  onClose: () => void;
  children: ReactNode;
  closeOnOverlayClick?: boolean;
  variant: 'fragments' | 'metro';
}

export const Modal: FC<IModalProps> = ({ onClose, children, closeOnOverlayClick = true, variant }) => {
  const [mouseDownOnOverlay, setMouseDownOnOverlay] = useState(false);

  const handleEsc = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onClose) {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [handleEsc]);

  const handleOverlayMouseDown = useCallback((e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      setMouseDownOnOverlay(true);
    } else {
      setMouseDownOnOverlay(false);
    }
  }, []);

  const handleOverlayClick = useCallback(
    (e: MouseEvent) => {
      if (closeOnOverlayClick && mouseDownOnOverlay && e.target === e.currentTarget && onClose) {
        onClose();
      }
      setMouseDownOnOverlay(false);
    },
    [closeOnOverlayClick, mouseDownOnOverlay, onClose],
  );

  return ReactDOM.createPortal(
    <>
      {variant === 'fragments' && (
        <FragmentsModalContent onClick={handleOverlayClick} onClose={onClose} onMouseDown={handleOverlayMouseDown}>
          {children}
        </FragmentsModalContent>
      )}

      {variant === 'metro' && (
        <MetroModalContent onClick={handleOverlayClick} onClose={onClose} onMouseDown={handleOverlayMouseDown}>
          {children}
        </MetroModalContent>
      )}
    </>,
    document.getElementById('app')!,
  );
};
